<template>
	<div class="login">
		
		<LoginHead>欢迎登录！</LoginHead>

		<div class="login_d2 flex j-a" :style="{ 'background-image': `url(${require('~a/imgs/9.jpg')})` }">
			<div class="login_d2_d1" v-if="device !== 'mobile'">欢迎来到江南药镇</div>
			<el-tabs v-model="activeName" class="login_d2_d2" type="border-card">
				<el-tab-pane name="1">
					<span slot="label"><i class="el-icon-user"></i> 账号登录</span>
					<div v-if="activeName === '1'">
						<el-form :model="ruleForm" label-position="top" status-icon :rules="rules" ref="ruleForm" label-width="100px"
						 class="demo-ruleForm">
							<el-form-item class="login_d2_d2_el1" prop="inp1">
								<el-input placeholder="请输入手机号码或用户名" v-model="ruleForm.inp1" prefix-icon="el-icon-mobile">
								</el-input>
							</el-form-item>
							<el-form-item prop="inp2">
								<el-input placeholder="请输入密码" type="password" v-model="ruleForm.inp2" prefix-icon="el-icon-lock">
								</el-input>
							</el-form-item>
							<el-form-item prop="type">
								<el-checkbox-group v-model="ruleForm.type">
									<el-checkbox label="我同意《江南药镇商城用户协议》" name="type">我同意<a @click.stop="XieYi">《江南药镇商城用户协议》</a></el-checkbox>
								</el-checkbox-group>
							</el-form-item>
							<el-form-item>
								<el-button class="login_d2_d2_el1_but" type="primary" :loading="loading" @click="submitForm('ruleForm')">登录</el-button>
							</el-form-item>
						</el-form>
					</div>
					<div class="login_d2_d2_foot">
						<div class="login_d2_d2_foot_d1">
							<span>没有账号？</span>
							<a @click="toReg()">立即注册</a>
						</div>
						<div class="login_d2_d2_foot_d1">
							<a @click="toSetPwd()">忘记密码？</a>
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>
		<div v-if="device !== 'mobile'" :style="{ height:'100px' }"></div>
		<Foot />
	</div>
</template>

<style>
	.login .el-form-item__content {
		line-height: 16px !important;
	}
</style>

<script>
import { mapGetters,mapActions } from "vuex"
import LoginHead from "@/components/LoginHead"
import Foot from "@/components/Foot";
	export default {
		computed: {
			...mapGetters(["device"])
		},
		components:{
			Foot,
			LoginHead
		},
		data() {
			var inp1Pass = (rule, value, callback) => {
				if (value === '') {
					return callback(new Error('手机号不能为空'));
				} else if (!(/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(value))) {
					return callback(new Error('手机号格式有误'));
				} else {
					callback();
				}
			};
			var inp2Pass = (rule, value, callback) => {
				if (value === '') {
					return callback(new Error('密码不能为空'));
				} else {
					callback();
				}
			};
			var typePass = (rule, value, callback) => {
				if (value.length > 0) {
					callback();
				} else {
					return callback(new Error('请同意用户协议'));
				}
			};
			
			
			var inp1Pass2 = (rule, value, callback) => {
				if (value === '') {
					return callback(new Error('手机号不能为空'));
				} else if (!(/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(value))) {
					return callback(new Error('手机号格式有误'));
				} else {
					callback();
				}
			};
			var inp2Pass2 = (rule, value, callback) => {
				if (value === '') {
					return callback(new Error('验证码不能为空'));
				} else {
					callback();
				}
			};
			
			var typePass2 = (rule, value, callback) => {
				if (value.length > 0) {
					callback();
				} else {
					return callback(new Error('请同意用户协议'));
				}
			};
			return {
				isSend:false,
				codetips:"发送验证码",
				loading:false,
				activeName:'1',
				pathObj:"",
				ruleForm: {
					inp1: '',
					inp2: '',
					type: ["我同意《江南药镇商城用户协议》"]
				},
				rules: {
					inp1: [{
						validator: inp1Pass,
						trigger: 'blur'
					}],
					inp2: [{
						validator: inp2Pass,
						trigger: 'blur'
					}],
					type: [{
						validator: typePass,
						type: 'array',
						required: true,
						message: '请同意用户协议',
						trigger: 'change'
					}]
				},
				ruleForm2: {
					inp1: '',
					inp2: '',
					type: ["我同意《江南药镇商城用户协议》"]
				},
				rules2: {
					inp1: [{
						validator: inp1Pass2,
						trigger: 'blur'
					}],
					inp2: [{
						validator: inp2Pass2,
						trigger: 'blur'
					}],
					type: [{
						validator: typePass2,
						type: 'array',
						required: true,
						message: '请同意用户协议',
						trigger: 'change'
					}]
				}
			}
		},
		
		watch: {

		},
		created: function() {
			this.pathObj = {
				path:this.$route.query.path,
				query:JSON.parse(this.$route.query.query)
			}
			console.log(this.$route);
			console.log(this.pathObj);

		},
		mounted: function() {

		},
		methods: {
			...mapActions("user",["login"]),
			XieYi(){
				this.$router.push({
					path: '/agreement',
				});
			},
			toReg() {
				this.$router.push("/reg")
			},
			toSetPwd() {
				this.$router.push("/login_setpwd")
			},
			sendCode(){
				var that = this
				that.isSend = true
				var num = 60
				that.codetips = num+"s后重新发送"
				var time = setInterval(function(){
					num--
					if(num > 0){
						that.codetips = num+"s后重新发送"
					}else{
						that.codetips = "重新发送"
						that.isSend = false
						clearInterval(time)
					}
				},1000)
			},
			submitForm(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						this.loading = true
						try {
						 	await this.login(this.ruleForm)
							this.loading = false
							if(this.pathObj.path){
								this.$router.replace(this.pathObj)
							}else{
								this.$router.replace("/")
							}
						} catch (error) {
							console.log("走到错误里");
							this.loading = false
						}
					}
				});
			},
			submitForm2(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						alert('submit!');
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped  lang="scss">
    



.login_d2{
	width: 100%;
	height: 473px;
	
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
}

.login_d2_d1{
	font-size: 46px;
	color: #ffffff;
}

.login_d2_d2{
	width: 344px;
	height: 360px;
}

.login_d2_d2_el1{
	margin-top: 25px;
}

.demo-ruleForm{
	width: 314px;
}

.login_d2_d2_el1_but{
	width: 100%;
	margin-top: 4px;
}

.login_d2_d2_foot{
	width: 100%;
	height: 50px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: flex-start;
}

.login_d2_d2_foot_d1{
	font-size: 14px;
	color: #333333;
}

.login_d2_d2_foot_d1 a{
	color: #409EFF;
}

</style>
